import { Fragment, ReactNode } from "react";
import ReactPlayer from "react-player";
import chateauEau from "../../images/slider/©Antoine_Meyssonnier-4653.jpg";
import thumbail from "../../images/logo/logo_aqua.svg";

type Props = {
  children?: ReactNode;
};

const HeroSection = (props: Props) => {
  return (
    <Fragment>
      <section
        className="relative flex items-center justify-center p-10 text-center bg-black/60 bg-blend-overlay lg:p-28"
        style={{
          backgroundImage: `url(${chateauEau})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div>
          <h1 className="text-3xl font-bold text-white md:text-5xl lg:text-6xl">
            Qui sommes-nous ?
          </h1>
          <p className="max-w-2xl mx-auto mt-4 text-base text-white/90 md:text-lg">
            Le service public de l'eau potable au service de 32 communes des
            Hauts-de-Seine et des Yvelines.
          </p>
        </div>
      </section>

      <div className="container mx-auto px-6 py-16 md:py-24 sm:px-10 lg:px-24">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="order-2 p-8 bg-white shadow-lg rounded-2xl md:p-10 lg:order-1">
            <p className="[font-family:'Roboto',Helvetica] text-[20px] font-black leading-tight text-[#44c6f4]">
              AQUAVESC
            </p>
            <p className="mt-4 [font-family:'Roboto',Helvetica] text-[17px] font-medium leading-8 text-[#3a3a3a] text-justify">
              est un établissement territorial en charge de la production, du
              traitement et de la distribution d'eau potable pour 32 communes
              des départements des Hauts-de-Seine et des Yvelines.
            </p>
            <p className="mt-4 [font-family:'Roboto',Helvetica] text-[16px] leading-8 text-[#3a3a3a] text-justify">
              Le Syndicat est administré par un Comité composé de délégués
              élus par les Conseils Municipaux des communes et des Conseils
              Communautaires des communautés associées. Le nombre de délégués
              est déterminé en fonction du nombre d'habitants.
            </p>
          </div>

          <div className="order-1 overflow-hidden shadow-lg rounded-2xl lg:order-2">
            <ReactPlayer
              playing={true}
              width="100%"
              url="https://www.youtube.com/watch?v=yp9F5W9jVHA"
              light={
                <img
                  src={thumbail}
                  alt="Thumbnail"
                  className="object-cover w-full"
                />
              }
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default HeroSection;
